// The quote request's shape, read the same way by every template's
// renderer and by the editor, so Classic and Trailhead cannot disagree
// about which fields a form shows. No imports, so the harness can run
// it in node.

export const QUOTE_FIELDS = [
    { key: 'organisation', label: 'Organization or landowner', placeholder: '' },
    { key: 'land_type', label: 'Land type', options: 'land_types' },
    { key: 'location', label: 'Location', placeholder: 'Nearest town, state' },
    { key: 'length', label: 'Approximate size', placeholder: 'e.g. 3 miles, 2 acres' },
    { key: 'timeline', label: 'Timeline', options: 'timelines' },
    { key: 'budget', label: 'Budget range', options: 'budgets' },
];

// The form's starting choices. TemplateStarters::QUOTE_DEFAULTS is the
// same list for the starter quote page; websitequote_verify runs this
// file in node and fails when the two differ.
export const QUOTE_DEFAULTS = {
    project_types: ['Trail design and layout', 'Machine-built trail', 'Hand-built / technical', 'Bike park or pump track', 'Adaptive trail', 'Assessment or master plan'],
    fields: { organisation: true, land_type: true, location: true, length: true, timeline: true, budget: true },
    land_types: ['Public land', 'Private land', 'Resort or bike park', 'Nonprofit-managed'],
    timelines: ['This season', 'Next season', 'Still planning'],
    budgets: ['Not sure yet', 'Under $50k', '$50k–$250k', '$250k+'],
    next_steps: [
        { title: 'We read it and reply', text: 'Within two working days, with questions or a time to talk.' },
        { title: 'Site walk', text: 'We walk the ground with you.' },
        { title: 'Written proposal', text: 'Scope, cost, schedule and what needs permitting.' },
    ],
};

const clean = (list) => (Array.isArray(list) ? list : []).map((s) => String(s ?? '').trim()).filter(Boolean);

export function quoteProjectTypes(config) {
    return clean(config?.project_types);
}

/** The optional fields this form shows, in order, with their choices. A
 *  choice field whose list is empty falls back to free text. */
export function quoteFieldList(config) {
    const on = config?.fields || {};
    return QUOTE_FIELDS.filter((f) => on[f.key]).map((f) => {
        const options = f.options ? clean(config?.[f.options]) : [];
        return { key: f.key, label: f.label, placeholder: f.placeholder || '', options: options.length ? options : null };
    });
}

export function quoteNextSteps(config) {
    return (Array.isArray(config?.next_steps) ? config.next_steps : [])
        .filter((s) => s && String(s.title ?? '').trim() !== '');
}
